import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKullaniciSecme_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKullaniciSecme_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetFirmayaBagliKullanicilar: any[];
  GetFirmayaBagliKullanicilar_dummy: any[];
  GetTeklifSepeti: any[];
  GetTeklifSepeti_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  GetTeklifNumarasi: any[];
  GetTeklifNumarasi_dummy: any[];
  InsertTeklifMas: number;
  InsertTeklifMas_dummy: number;
  InsertTeklifTra: number;
  InsertTeklifTra_dummy: number;
  ForEach1: GetTeklifSepeti;
  ForEach1_dummy: GetTeklifSepeti;
  TeklifSonrasiSepetSil: number;
  TeklifSonrasiSepetSil_dummy: number;
  InsertTeklifGorusmeleri: number;
  InsertTeklifGorusmeleri_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  SendMail: boolean;
  SendMail_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class KullaniciSecme_ScreenBase extends React.PureComponent<
  IKullaniciSecme_ScreenProps,
  any
> {
  kullanicisecme_340651_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Save",
          TagName: "Button1_label",
        },
        {
          Id: 373749,
          PropertyName: "value",
          Value: "Brand Selection",
          TagName: "Label3_value",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "e45aa35a-21e5-41eb-8c0e-e68dea4783ea",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 401253,
          PropertyName: "value",
          Value: "Firmaya Ait Kullanıcılar",
        },
        {
          Id: 827896,
          PropertyName: "value",
          Value: "Aşağıdan hangi kullanıcıya İşlem Yapacağınızı Seçebilirsiniz",
        },
        { Id: 373749, PropertyName: "value", Value: "Kullanıcılar" },
        { Id: 64155, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach1: any[];

  constructor(props) {
    super(props);
    this.kullanicisecme_340651_value_kuikaAutoCompleteRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetFirmayaBagliKullanicilar: [],
      GetTeklifSepeti: [],
      GoBack: "",
      GetKullanici: [],
      GetTeklifNumarasi: [],
      InsertTeklifMas: 0,
      ForEach: false,
      TeklifSonrasiSepetSil: 0,
      InsertTeklifGorusmeleri: 0,
      Notify: false,
      SendMail: false,
      NAVIGATE: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kullanicisecme", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KullaniciSecmePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kullanicisecme", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kullanicisecme", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KullaniciSecmePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KullaniciSecmePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      kulID_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      CariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      MusteriMarka_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriMarka ??
          this.props.screenInputs.musterimarka,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciSecme/KullaniciSecmePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetFirmayaBagliKullanicilar =
      result?.data.getFirmayaBagliKullanicilar;

    formVars.kullanicisecme_340651_options =
      stateVars.GetFirmayaBagliKullanicilar;
    stateVars.GetTeklifSepeti = result?.data.getTeklifSepeti;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciSecmePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciSecmePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_340651 =
      stateVars.GetFirmayaBagliKullanicilar ??
      this.state.GetFirmayaBagliKullanicilar;
    stateVars.dataSource_340651 =
      stateVars.GetFirmayaBagliKullanicilar ??
      this.state.GetFirmayaBagliKullanicilar;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KullaniciSecmeComponent_266090_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KullaniciSecmeComponent_64155_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "kullanicisecme_340651_value",
          "value",
          "GetFirmayaBagliKullanicilar",
          "kullaniciKodu",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "kullanicisecme_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kullanicisecme_340651_value",
            "value",
            "GetFirmayaBagliKullanicilar",
            "kullaniciKodu",
            "kullaniciKodu"
          )
        ),
        "string"
      ),
      isPlasiyer_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      GenelToplam_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.GenelToplam ??
          this.props.screenInputs.geneltoplam,
        "number"
      ),
      KullaniciID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      ParaBirimi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.paraBirimi ??
          this.props.screenInputs.parabirimi,
        "number"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
      TalepNo_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TalepNo ?? this.props.screenInputs.talepno,
        "string"
      ),
      PlasiyerKodu_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerKodu ??
          this.props.screenInputs.plasiyerkodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciSecme/KullaniciSecmeComponent_64155_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    stateVars.GetTeklifNumarasi = result?.data.getTeklifNumarasi;
    stateVars.InsertTeklifMas = result?.data.insertTeklifMas;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciSecmeComponent_64155_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciSecmeComponent_64155_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.birimFiyat),
        "number"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.miktar),
        "number"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.stokAdi),
        "string"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.stokKodu),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.musteriMarka),
        "string"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.firmaKodu),
        "string"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.kdvOrani),
        "number"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.excelKod),
        "string"
      ),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.excelNot1),
        "string"
      ),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.excelNot2),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciSecme/KullaniciSecmeComponent_64155_onClick_foreach1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertTeklifTra = result?.data.insertTeklifTra;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  KullaniciSecmeComponent_64155_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetTeklifSepeti)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetTeklifSepeti
      )) {
        this.ForEach1 = item;
        await this.KullaniciSecmeComponent_64155_onClick_foreach1();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciSecmeComponent_64155_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KullaniciSecmeComponent_64155_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      musteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriMarka ??
          this.props.screenInputs.musterimarka,
        "string"
      ),
      Mesaj_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Mesaj ?? this.props.screenInputs.mesaj,
        "string"
      ),
      KullaniciAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      isPlasiyer_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciSecme/KullaniciSecmeComponent_64155_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSonrasiSepetSil = result?.data.teklifSonrasiSepetSil;
    stateVars.InsertTeklifGorusmeleri = result?.data.insertTeklifGorusmeleri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciSecmeComponent_64155_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciSecmeComponent_64155_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "cf015033_3e96_888e_f8a9_101f47e74dff_notify",
        this.defaultML,
        "Teklif Başarıyla Oluşturuldu"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciSecmeComponent_64155_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KullaniciSecmeComponent_64155_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "kullanicisecme_340651_value",
          "value",
          "GetFirmayaBagliKullanicilar",
          "kullaniciKodu",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "kullanicisecme_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "4c84dda4-6bfa-427f-b8e4-7c2478ca5811",
          "string"
        ),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "kullanicisecme_340651_value",
            "value",
            "GetFirmayaBagliKullanicilar",
            "kullaniciKodu",
            "kullaniciKodu"
          )
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Yeni Teklif", "string"),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      MusteriAdi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MusteriAdi ??
          this.props.screenInputs.musteriadi,
        "string"
      ),
      PlasiyerAd_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.PlasiyerAdi ??
          this.props.screenInputs.plasiyeradi,
        "string"
      ),
      siparisNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
      plasiyerMail_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciSecme/KullaniciSecmeComponent_64155_onClick4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciSecmeComponent_64155_onClick5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciSecmeComponent_64155_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "86c44bd6_ec35_e5f5_17f1_76261ec2b1b3_notify",
        this.defaultML,
        "Müşteriye Bilgilendirme Maili Başarıyla Gönderildi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "KullaniciSecme",
      "TeklifDurumlari",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KullaniciSecmePageInit();
    }
  }
}
